import { Collection } from '../../common';
import Panel from './Panel';

export default class Panels extends Collection {}

Panels.prototype.model = Panel;
